import React from 'react';
import { Modal, ModalContent as Content, Button, Layout, Title } from '~ui';

export default function DialogAlertView({
  id,
  message,
  description,
  ok,
  variant,
  sendResult,
}) {
  return (
    <Modal
      className='w-[8rem]'
      important={true}
      onClose={() => sendResult(id)}
    >
      <Content>
        <Layout>
          <Title>
            {variant == 'error' ? '⛔️' : ''} {message}
          </Title>
          <div className='text-foreground'>{description}</div>

          <Button data-block autoFocus onClick={() => sendResult(id)}>
            {ok || 'OK'}
          </Button>
        </Layout>
      </Content>
    </Modal>
  );
}
